//# sourceMappingURL=path.mjs.map
/// <reference types="./path.d.mts" />
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";

export function from_segments(segments) {
  let _pipe = segments;
  let _pipe$1 = $list.map(
    _pipe,
    (_capture) => { return $string.replace(_capture, "/", ""); },
  );
  let _pipe$2 = $list.map(_pipe$1, $uri.percent_encode);
  let _pipe$3 = $string.join(_pipe$2, "/");
  return ((_capture) => { return $string.append("/", _capture); })(_pipe$3);
}
